import { bankTransferPaymentId, InvoiceContextType } from '@/context/InvoiceContext';
import { UseMutationResult } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { FetchError } from '@/hooks/useApi';

export const InvoiceContext = createContext<InvoiceContextType>({
  invoice: undefined,
  setInvoiceReferenceCode: () => {},
  isLoading: false,
  queryError: null,
  refetchInvoice: () => Promise.resolve(),
  bankTransferPaymentId,
  postInvoice: {} as UseMutationResult<string, FetchError, any, unknown>,
  resetInvoice: () => Promise.resolve(),
  minimumPaymentAmount: 100
});

export const useInvoice = () => {
  const context = useContext(InvoiceContext);

  vtlog('useInvoice:', context);

  if (context === null) {
    throw new Error('useInvoiceContext must be used within an InvoiceProvider');
  }

  return context;
};
